import styles from "./PageGalleryComp.module.scss";
import { useState, useEffect } from 'react';
import Gallerymodal from "../Gallerymodal/Gallerymodal";
import Image from "next/image";

function SkeletonLoader() {
    return (
        <div className={styles.skeletonLoader}>
            <div className={styles.skeletonImage}></div>
        </div>
    );
};

export default function PageGalleryComp({ galleryImages }) {
    const [selectedCategory, setSelectedCategory] = useState('all');
    const [clickedImage, setClickedImage] = useState(null);
    const [currentIndex, setCurrentIndex] = useState(null);
    const [visibleImages, setVisibleImages] = useState(9); // Initial number of images to show
    const [loading, setLoading] = useState(true);

    const categories = [...new Set(galleryImages.map(image => image.category))];
    const filteredImages = selectedCategory === 'all' ? galleryImages : galleryImages.filter(image => image.category === selectedCategory);

    useEffect(() => {
        setLoading(true);
        const timer = setTimeout(() => setLoading(false), 1000); // Adjust as needed
        return () => clearTimeout(timer);
    }, [selectedCategory]);

    const handleClick = (item, index) => {
        const originalIndex = galleryImages.findIndex(image => image.bgImage === item.bgImage);
        setCurrentIndex(originalIndex);
        setClickedImage(item.bgImage || item.video);
    }

    const loadMoreImages = () => {
        setLoading(true); // Reset loading state
        setVisibleImages(prevVisibleImages => prevVisibleImages + 9);
        const timer = setTimeout(() => setLoading(false), 1000); // Simulate loading
        return () => clearTimeout(timer);
    }

    const formatCategory = (category) => {
        return category
            .split('_')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ');
    };

    return (
        <>
            <div className="d-flex gap-2 justify-content-center flex-wrap">
                <button onClick={() => setSelectedCategory('all')} className={selectedCategory === 'all' ? 'filtered_btn secound_common_btn' : 'secound_common_btn'}>All</button>
                {categories.map(category => (
                    <button key={category} onClick={() => setSelectedCategory(category)} className={selectedCategory === category ? 'filtered_btn secound_common_btn' : 'secound_common_btn'}>
                        {formatCategory(category)}
                    </button>
                ))}
            </div>
            <div className={styles.gallery_page_comp}>
                {loading ? (
                    Array.from({ length: visibleImages }).map((_, index) => (
                        <div
                            className={styles.gallery_page_comp_child}
                            key={index}
                        >
                            <SkeletonLoader />
                        </div>
                    ))
                ) : (
                    filteredImages.slice(0, visibleImages).map((item, index) => (
                        <div
                            className={styles.gallery_page_comp_child}
                            key={index}
                        >
                            {item.bgImage ?
                                <Image
                                    src={item.bgImage}
                                    fill
                                    alt={item.altText}
                                    onClick={() => handleClick(item, index)}
                                /> :
                                <video controls onClick={() => handleClick(item, index)}
                                >
                                    <source src={item.video} type="video/mp4" />
                                    Your browser does not support the video tag.
                                </video>
                            }
                        </div>
                    ))
                )}
            </div>
            {filteredImages.length > visibleImages && (
                <div className="d-flex justify-content-center">
                    <button onClick={loadMoreImages} className="common_btn mt-4">Load More</button>
                </div>
            )}
            {clickedImage !== null && (
                <Gallerymodal
                    galleryImages={galleryImages}
                    currentIndex={currentIndex}
                    setClickedImage={setClickedImage}
                />
            )}
        </>
    );
}
